import type { ReactNode } from "react";
import type { ButtonProps as BsButtonProps } from "react-bootstrap";

import classNames from "classnames";
import { Button as BsButton, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import styles from "./Button.module.scss";

interface IButtonProps extends BsButtonProps {
  children: ReactNode;
  isLoading?: boolean;
}

function Button({
  children,
  isLoading,
  disabled,
  className,
  ...props
}: IButtonProps) {
  const { t } = useTranslation();

  return (
    <BsButton
      {...props}
      disabled={isLoading || disabled}
      className={classNames({ loading: isLoading }, styles.btn, className)}
    >
      {isLoading && (
        <span
          className={classNames(
            "d-flex align-items-center justify-content-center gap-2",
            styles.loader
          )}
        >
          <Spinner animation="border" size="sm" />
          <span>{t("components.button.loading")}</span>
        </span>
      )}
      <span
        className={classNames(
          "d-flex align-items-center justify-content-center gap-2",
          styles.content
        )}
      >
        {children}
      </span>
    </BsButton>
  );
}

export default Button;
